// src/components/AppComponents/NavBar/menuItems.ts

import {
  RiDashboardLine,
  RiIdCardLine,
  RiLinksLine,
  RiShieldUserLine,
  RiSwap2Line,
} from '@remixicon/react';

import { NAVBAR_SOURCES } from './NavBarSources';

import i18n from '@/shared/i18n/i18n';
import { CUSTOMER_TYPES, TUserCustomerType } from '@/shared/types/customer';

export const getMenuItems = (
  customerType: TUserCustomerType,
  isRestrictedView: boolean,
  showKYC: boolean,
) => {
  const customerFundingHomeItem =
    customerType === CUSTOMER_TYPES.adtech ||
    customerType === CUSTOMER_TYPES.ssp
      ? { label: i18n.t('navBar.revenues'), path: NAVBAR_SOURCES.revenues }
      : customerType === CUSTOMER_TYPES.dsp
        ? { label: i18n.t('navBar.spend'), path: NAVBAR_SOURCES.revenues }
        : customerType === CUSTOMER_TYPES.creator
          ? {
              label: i18n.t('navBar.deliverables'),
              path: NAVBAR_SOURCES.revenues,
            }
          : {
              label: i18n.t('navBar.commissions'),
              path: NAVBAR_SOURCES.commissions,
            };

  const menu = [
    {
      label: i18n.t('navBar.dashboard'),
      icon: RiDashboardLine,
      path: NAVBAR_SOURCES.dashboard,
      condition: !isRestrictedView,
    },
    {
      label: i18n.t('navBar.kyc'),
      icon: RiShieldUserLine,
      path: NAVBAR_SOURCES.kyc,
      condition: showKYC,
    },
    {
      label: i18n.t('navBar.funding'),
      icon: RiSwap2Line,
      condition: !isRestrictedView,
      submenu: [
        customerFundingHomeItem,
        {
          label: i18n.t('navBar.invoiceLedger'),
          path: NAVBAR_SOURCES.invoicesLedger,
        },
        {
          label: i18n.t('navBar.activity'),
          path: NAVBAR_SOURCES.activity,
        },
        { label: i18n.t('navBar.documents'), path: NAVBAR_SOURCES.documents },
      ],
    },
    {
      label: i18n.t('navBar.sources'),
      icon: RiLinksLine,
      condition: !isRestrictedView,
      submenu: [
        // {
        //   label: i18n.t('navBar.fundingRules'),
        //   path: NAVBAR_SOURCES.fundingRules,
        // },
        {
          label: i18n.t('navBar.commercialTerms'),
          path: NAVBAR_SOURCES.commercialTerms,
        },
      ],
    },
    {
      label: i18n.t('navBar.account'),
      icon: RiIdCardLine,
      condition: true,
      submenu: [
        {
          label: i18n.t('navBar.businessDetails'),
          path: NAVBAR_SOURCES.businessDetails,
        },
        { label: i18n.t('navBar.users'), path: NAVBAR_SOURCES.users },
        {
          label: i18n.t('navBar.bankAccounts'),
          path: NAVBAR_SOURCES.bankAccounts,
        },
      ],
    },
  ];

  return menu.filter((item) => item.condition);
};
